import React from "react";
import { NavLink } from "react-router-dom";

function Impressum() {
  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center bg-footerBgColor text-white py-20 px-4">
      <div className="max-w-2xl w-full bg-[#23243a] rounded-xl shadow-lg p-8 relative">
        <NavLink to="/" className="absolute top-4 right-4">
          <img
            src="/images/logo-white.svg"
            alt="Diligent Logo"
            className="w-[120px] hover:opacity-80 transition-opacity"
          />
        </NavLink>
        <h1 className="text-3xl font-bold mb-6 text-center">IMPRESSUM</h1>
        <div className="space-y-3 text-lg">
          <div>
            <span className="font-semibold">Jobdaten ein Produkt der Diligent Recruitment GmbH</span>
          </div>
          <div>Faberstrasse 11, 76287 Rheinstetten</div>
          <div>
            <span className="font-semibold">Telefon:</span> +49 (0) 721-75401610
          </div>
          <div>
            <span className="font-semibold">Mobil:</span> +49 (0) 152 24076038
          </div>
          <div>
            <span className="font-semibold">Mobil:</span> +49 (0) 152 26712572
          </div>
          <div>
            <span className="font-semibold">E-Mail:</span>{" "}
            <a
              href="mailto:info@jobdaten.de"
              className="underline text-[#B588FF]"
            >
              info@jobdaten.de
            </a>
          </div>
          <div>
            <span className="font-semibold">Web:</span>{" "}
            <a
              href="https://www.jobdaten.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-[#B588FF]"
            >
              www.jobdaten.com
            </a>
          </div>
          <div>
            <span className="font-semibold">Geschäftsführer:</span> Shawn Siegrist & Jochen Sagert
          </div>
          <div>
            <span className="font-semibold">Registergericht:</span> Mannheim
          </div>
          <div>
            <span className="font-semibold">Handelsregisternummer:</span> HRB740899
          </div>
          <div>
            <span className="font-semibold">USt-IdNr:</span> DE345879438
          </div>
        </div>
      </div>
    </div>
  );
}

export default Impressum;
